import $ from 'jquery';

/** Internal dependencies */
import { NCST } from '../';
import VideoPlayer from '../Templates/VideoPlayer.html';

export default class VideoLightbox {
	constructor() {
		this.thumbnails = [];
		this.lightbox;
	}

	/**
	 * Performs setup for this type of lightbox.
	 */
	init() {
		// Nothing to do, but required for all lightbox types.
	}

	/**
	 * Retrieves all thumbnails that are handled by this type of lightbox.
	 *
	 * @return {jQuery obj} The jQuery object containing all matched thumbs.
	 */
	getThumbs() {
		this.thumbnails = $( 'a[data-ncst-lightbox="video"]' ).filter(
			function () {
				return /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(v\/|embed\/?)?(.*)/i.test(
					$( this ).attr( 'href' )
				);
			}
		);
		return this.thumbnails;
	}

	/**
	 * Returns the options for a video lightbox.
	 *
	 * @param  {jQuery obj} $item The clicked <a> tag that triggered the lightbox.
	 * @return {obj}              PhotoSwipe options.
	 */
	getOptions( $item ) {
		return {
			index: 0,
			zoomEl: false,
			shareEl: false,
			maxSpreadZoom: 1,
			mainClass: 'pswp--minimal--dark ncst-video-lightbox',
			closeElClasses: [
				'item',
				'img',
				'caption',
				'zoom-wrap',
				'ui',
				'top-bar',
			],
			getDoubleTapZoom: function ( isMouseClick, item ) {
				return item.initialZoomLevel;
			},
			tapToClose: true,
			clickToCloseNonZoomable: true,
			showHideOpacity: true,
			hideAnimationDuration: 0,
			showAnimationDuration: 0,
			getThumbBoundsFn: false,
		};
	}

	/**
	 * Will transform a single video element into a PhotoSwipe
	 * item and wrap it in an array.
	 *
	 * @param  {jQuery obj} $element The clicked <a> tag that triggered the lightbox.
	 * @return {array}               Item array for PhotoSwipe.
	 */
	getItems( $item ) {
		// create slide object
		var item = {
			html: VideoPlayer,
		};

		return [ item ];
	}

	async setLightbox( $item, lightbox ) {
		this.lightbox = lightbox;
		const { video } = NCST.controllers;

		// Width and height are 16:9 with max of 80% in either dimension
		const player = await video.createYTPlayer(
			'ncst-lightbox-video-player',
			$item.attr( 'href' ),
			{
				width: Math.floor( NCST.elements.$win.height() * 1.42 ),
				height: Math.floor( NCST.elements.$win.height() * 0.8 ),
			}
		);

		lightbox.listen( 'close', function () {
			player.ncstAnalytics.fireAnalyticsEvent(
				player.getVideoData().video_id,
				'Lightbox Close'
			);
			video.destroyYTPlayer( player );
		} );
	}
}
